import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';

export default props => {
  return (
    <React.Fragment>
      <DialogTitle id="max-width-dialog-title">
        Leading Agent Category
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          X, Y, Z where, <br />
          X = # of Leading agents with CICO above Gold threshold for the
          selected day/week/month <br />
          Y = # of Leading agents with CICO above Silver threshold for the
          selected day/week/month <br />
          Z = # of Leading agents with CICO above Bronze threshold for the
          selected day/week/month <br />
          <br />
          Threshold values are: <br />
          Gold = {props.summary.gold_category_threshold} <br />
          Silver = {props.summary.silver_category_threshold} <br />
          Bronze = {props.summary.bronze_category_threshold} <br />
        </DialogContentText>
      </DialogContent>
    </React.Fragment>
  );
};
